import { render, staticRenderFns } from "./AzrPlayerComponent.vue?vue&type=template&id=f29059d6&scoped=true"
import script from "./AzrPlayerComponent.vue?vue&type=script&lang=ts"
export * from "./AzrPlayerComponent.vue?vue&type=script&lang=ts"
import style0 from "./AzrPlayerComponent.vue?vue&type=style&index=0&id=f29059d6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f29059d6",
  null
  
)

export default component.exports